module.exports = __webpack_public_path__ + "static/media/paragraph-rtl.7e19b6b2.svg";